import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ICoursesCalendarSlotDto } from "@ryde/shared";

import { CoursesCalendarCellPassengersBadge } from "./courses-calendar-cell.passengers-badge";
import {
  getCoursesCalendarPassengerCounts,
  getCoursesCalendarPassengersModifierClass,
} from "./courses-calendar-cell.utils";

interface ICoursesCalendarCellPassengersCountProps {
  slot: ICoursesCalendarSlotDto;
  tooltipDisabled?: boolean;
}

export const CoursesCalendarCellPassengersCount: FC<
  ICoursesCalendarCellPassengersCountProps
> = ({ slot, tooltipDisabled }) => {
  const { t } = useTranslation();
  const counts = getCoursesCalendarPassengerCounts(slot);
  const modifierClass = getCoursesCalendarPassengersModifierClass(slot, counts);

  const tooltip = slot.hasRide ? (
    <span>
      {t("course.calendar.passengersOnRideTooltip", {
        count: counts.onRide,
      })}
      <br />
      {t("course.calendar.passengersNotOnRideTooltip", {
        count: counts.notOnRide,
      })}
    </span>
  ) : (
    t("course.calendar.bookingsTooltip", { count: counts.notOnRide })
  );

  return (
    <CoursesCalendarCellPassengersBadge
      onRide={counts.onRide}
      notOnRide={counts.notOnRide}
      showRatio={slot.hasRide}
      modifierClass={modifierClass}
      tooltip={tooltip}
      tooltipDisabled={tooltipDisabled}
    />
  );
};
